export enum ERROR_NAMES {
  SERVICE_TYPE_IS_NOT_REGISTERED = 'SERVICE_TYPE_IS_NOT_REGISTERED'
}